import {appUrl} from '@frontend/AppUrl'
import {trans} from '@frontend/helpers'
import {FooterCompanyLicenseLink} from '@frontend/modules/layout/footer/FooterCompanyLicenseLink'
import {LogoWithLabel} from '@shared/components/Logo/LogoWithLabel'
import clsx from 'clsx'
import {HtmlContent} from 'swayok-react-mdb-ui-kit/components/Typography/HtmlContent'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

// Логотип и информация о лицензировании в футере.
export function FooterLogoAndLegalInfo() {

    return (
        <div className="text-center text-md-end mb-3 mb-md-0">
            <div
                className={clsx(
                    'd-flex flex-column gap-1 align-items-center justify-content-start',
                    'flex-sm-row gap-sm-4 justify-content-sm-center',
                    'flex-md-column gap-md-1 justify-content-md-start align-items-md-end',
                    'flex-lg-row gap-lg-4 justify-content-lg-end align-items-lg-center'
                )}
            >
                <div>
                    <LogoWithLabel
                        url={NavigationService.makeFullUrl(appUrl().index)}
                        label={trans().common.logo_label}
                        alt={trans().common.app_name}
                    />
                </div>
                <FooterCompanyLicenseLink />
            </div>
            <HtmlContent
                html={trans().common.footer.company_info}
                block
                className="mt-2 fs-7"
            />
        </div>
    )
}
